import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect } from "react";
import QRCode from './../utils/resources/ModuleIcons/QR.png'
import IoTColud from './../utils/resources/ModuleIcons/Cloud.png'

const AutoRegistringModulePage = () => {
    const { t } = useTranslation();
    const context: IOutletContext = useOutletContext();

    useEffect(() => {
        context.setState(t('AutomaticSetup'));
    }, [context, t]);



    return (
        <>
            <div className='row border-0 mx-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-lg-6 px-2 mt-2'>
                    <div className='rounded-1 p-3 h-100 d-flex align-items-center' style={{ backgroundColor: 'var(--IDBlackLight)' }}>
                        <div><img src={QRCode} width={'100%'} /></div>
                    </div>
                </div>
                <div className='col-12 col-lg-6 px-2 mt-2'>
                    <div className='rounded-1 p-3' style={{ backgroundColor: 'var(--IDBlackLight)' }}>
                        <img src={IoTColud} width={'100%'} />
                    </div>
                </div>
            </div >

        </>
    )
}

export default AutoRegistringModulePage;
